// Unsplash tırnak/güzellik havuzu — picsum yerine tüm fallback'ler buradan.
// Fotoğraf ID'leri güzellik arşivinden seçildi; yüklenemezse bileşenler
// ikinci yedek olarak lokal görsellere döner (SmartImage fallback zinciri).

const u = (id: string, w = 800, h = 800) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&h=${h}&auto=format&fit=crop`;

export const unsplash = {
  /** Pembe manikürlü eller */
  nails: (w = 800, h = 800) => u("photo-1604654894610-df63bc536371", w, h),
  /** Kırmızı oje şişeleri */
  polish: (w = 800, h = 800) => u("photo-1632345031435-8727f6897d53", w, h),
  /** Manikür uygulaması */
  manicure: (w = 800, h = 800) => u("photo-1607779097040-26e80aa78e66", w, h),
  /** Güzellik salonu */
  salon: (w = 800, h = 800) => u("photo-1522337660859-02fbefca4702", w, h),
  /** Kozmetik düz çekim */
  cosmetics: (w = 800, h = 800) => u("photo-1519014816548-bf5fe059798b", w, h),
  /** Ruj */
  lipstick: (w = 800, h = 800) => u("photo-1586495777744-4413f21062fa", w, h),
  /** Makyaj ürünleri */
  makeup: (w = 800, h = 800) => u("photo-1522335789203-aabd1fc54bc9", w, h),
  /** Far paleti */
  palette: (w = 800, h = 800) => u("photo-1596462502278-27bfdc403348", w, h),
  /** Makyaj portresi */
  portrait: (w = 800, h = 800) => u("photo-1487412947147-5cebf100ffc2", w, h),
  /** Serum şişesi */
  serum: (w = 800, h = 800) => u("photo-1620916566398-39f1143ab7be", w, h),
  /** Cilt bakımı pembe */
  skincare: (w = 800, h = 800) => u("photo-1571781926291-c477ebfd024b", w, h),
  /** Krem dokusu */
  cream: (w = 800, h = 800) => u("photo-1570172619644-dfd03ed5d881", w, h),
  /** Krem kavanozu */
  jar: (w = 800, h = 800) => u("photo-1608248543803-ba4f8c70ae0b", w, h),
  /** Cilt bakım şişesi */
  bottle: (w = 800, h = 800) => u("photo-1556228720-195a672e8a03", w, h),
  /** Oje şişesi detayı */
  polishBottle: (w = 800, h = 800) => u("photo-1610992015732-2449b76344bc", w, h),
  /** Makyaj fırçaları */
  brushes: (w = 800, h = 800) => u("photo-1598440947619-2c35fc9aa908", w, h),
};
